<template>
    <button class="btn btn-info" @click="pesertaData">
        <slot><i class="fas fa-user"></i></slot>
    </button>
</template>

<script>
    import { EventBus } from '../eventBus.js';

    export default{
        //extends: ExampleComponent,
        props: ['id', 'name'],
        methods: {
            pesertaData() {
                // alert(`I am ${this.name}!`)
                EventBus.$emit('pesertaValue', this.id,this.name) 
            }
        },
    }
</script>